export default __webpack_public_path__ + "static/media/logo.5f3f2538.svg";